export const body = {
    paddingRight: "30px",
    paddingTop: "20px"
};

export const columnRight = {
    textAlign: "right"
};

export const emailNote = {
    color: "red",
    fontWeight: "bold"
};

//MOBILE
export const mobile_leftMargin = {
    paddingLeft: "10px"
};

export const mobile_updateButton = {
    width: "100%"
};
